import { render, staticRenderFns } from "./PlayerAccessRequest.vue?vue&type=template&id=492424d4&scoped=true&"
import script from "./PlayerAccessRequest.vue?vue&type=script&lang=ts&"
export * from "./PlayerAccessRequest.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerAccessRequest.vue?vue&type=style&index=0&id=492424d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492424d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
